module.exports = "https://coursera_assets.s3.amazonaws.com/images/034d4b41c2b357baabccaff22ba201ff.png";